import PropTypes from 'prop-types';
import { useContext } from 'react';
import { useQuery } from '@apollo/client';
import PostBlockGrid from '../../PostBlock/PostBlockGrid';
import { TAG_PAGES_QUERY } from '../../Tags/TagPagesQuery';
import AppContext from '../../../context/AppContext';

export default function MoreLikeThis(props) {
	const { post } = props;
	const { isUsTraffic } = useContext(AppContext);

	const tags = post.tags?.nodes;
	const wpTags = tags.map((tag) => tag.slug).join(','); // the tags that we want to query

	const { loading, error, data } = useQuery(TAG_PAGES_QUERY, {
		variables:
			{
				tags: wpTags,
				excludePosts: post.databaseId.toString(),
				excludeUS: isUsTraffic === true,
			},
	});

	if (error) return null;

	// Return only first three posts
	const posts = (data && data?.tagPages.found_posts) ? data?.tagPages?.posts.slice(0, 3) : [];

	const title = (posts && posts.length === 0) ? null : 'More Like This';

	return (
		<div className="more-like-this">
			<PostBlockGrid posts={posts} title={title} isLoader={loading} />
		</div>
	);
}

MoreLikeThis.propTypes = {
	post: PropTypes.object.isRequired,
};
